import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { concat, of } from 'rxjs';
import { concatMap, tap } from 'rxjs/operators';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { SolcitudesService } from 'src/app/core/services/solicitudes/solcitudes.service';
import { SolicudesAsignadasService } from 'src/app/core/services/solicitudesAsignadas/solicudes-asignadas.service';
import { UserService } from 'src/app/core/services/user/user.service';
import { SstService } from 'src/app/services/sst/sst.service';
import { PostSolicitud } from 'src/app/shared/models/sst/postSolicitud';
import { Solicitud } from 'src/app/shared/models/sst/solicitud';
import { SolicitudAsignada } from 'src/app/shared/models/sst/solicitudAsignada';
import { User } from 'src/app/shared/models/sst/solicitudes';

@Component({
  selector: 'app-update-ssta',
  templateUrl: './update-ssta.component.html',
  styleUrls: ['./update-ssta.component.scss']
})
export class UpdateSstaComponent implements OnInit {

  form: FormGroup;

  checked: boolean = false;

  transportistas: User[] = []
  spinner = true;

  minDateValue = new Date();

  solicitudes: any[] = [];

  userActual: User;
  roles: string[] = [];
  idUserActual = "";

  tipo: string;

  requests: number[] = [];
  idSsta;

  ssta: SolicitudAsignada;

  constructor(private authService: AuthService, private sstService: SstService, private datepipe: DatePipe,
    private solicitudesAsignadasServices: SolicudesAsignadasService,
    private messageService: MessageService, private route: ActivatedRoute,
    private userService: UserService, private router: Router) {
    let { id } = this.route.snapshot.params;
    this.idSsta = id;
  }


  ngOnInit(): void {
    this.rolesInit();
  }


  rolesInit() {
    this.authService
      .actual()
      .pipe(
        tap({
          next: (data) => {
            this.userActual = data;
            this.idUserActual = data.id;
            this.roles = data.rolenames;
          },
          complete: () => {
          },
        }),
        concatMap(() => this.getSstaById()),
        concatMap(() => this.getTransportistas()),
        concatMap(() => concat(of(this.startFormEditSsta()))),
        concatMap(() => concat(of(
          this.spinner = false,
        ))),
      ).subscribe()

  }

  startFormEditSsta() {
    const form = new FormGroup(
      {
        checked: new FormControl(this.ssta.status == 'REJECTED' ? false : this.ssta.expressService),
        transportista: new FormControl(this.ssta.transporter, [Validators.required]),
        // fechaProgramacion: new FormControl(new Date(res.programmingDate), [Validators.required]),
        fechaProgramacion: new FormControl(new Date(this.datepipe.transform((this.ssta.programmingDate), 'yyyy/MM/dd')), [Validators.required]),
      });
    this.form = form;

    if (this.ssta.status == "FINISHED") {
      this.form.addControl('transportGuideArray', new FormArray(this.ssta.transportGuides.length <= 0 ? [this.createTransportGuide()] : []))

      const transportGuideArray = this.form.get("transportGuideArray") as FormArray;

      for (let i = 0; i < this.ssta.transportGuides.length; i++) {
        transportGuideArray.push(this.createTransportGuide(this.ssta.transportGuides[i]));
      }
    }
  }

  getSstaById() {
    return this.solicitudesAsignadasServices.getById(this.idSsta).pipe(
      tap(
        {
          next: (data) => {
            this.ssta = data;
            console.log(data);
            
          },
          error: (error) => {
            this.messageService.add({
              key: "msg",
              severity: "error",
              summary: "Error",
              detail: error.error
                ? error.error.message
                : "Ups! ocurrio un error",
            });
          }
        }
      )
    )
  }

  getTransportistas() {
    return this.userService.getByRol("transportista").pipe(
      tap({
        next: (res) => {
          res.forEach((e) => {
            this.transportistas.push({ name: e.username, code: e.id })
          });
        },
        complete: () => {
        }
      })
    );
  }

  showPopUpEditarSsta() {
    let data = {}
    var datePipe = new DatePipe('en-US');
    data['programmingDate'] = datePipe.transform(this.form.get("fechaProgramacion").value, 'YYYY-MM-dd');
    data['transporter'] = this.form.get("transportista").value;
    data['requests'] = this.ssta.requests.map((element)=>{return element.id});
    data['transports'] = this.ssta.transports.map((element)=>{
      return     {
        "driverId": element.driver ? element.driver.id : null,
        "id": element.id || null,
        "tractorId": element.tractor ? element.tractor.id : null,
        "trailerId": element.trailer ? element.trailer.id : null
      }
    })
    data['expressService'] = this.form.get("checked").value;
    data['id'] = new Number(this.idSsta);
    data['status'] = this.ssta.status === 'REJECTED' ? "PENDING" : this.ssta.status
    data['transportGuideNumbers'] = this.transportGuideArray ? this.transportGuideArray.controls.map((element) => { return element.get('transportGuide').value }) : []

    console.log(data);

    this.solicitudesAsignadasServices.editSst(data).subscribe(
      res => {
        this.messageService.add({
          key: 'msg',
          severity: "success",
          summary: "Confirmado",
          detail: "La solicitud asignada se ha editado con exito",
        });
        this.router.navigate(["/solicitudes-asignadas"]);
      },
      err => {
        this.messageService.add({
          key: 'msg', severity: 'error', summary: 'Error', detail: (err.error) ? err.error.message : "Ups! ocurrio un error",
        });

      })

  }

  navegarDocumentSst(idSst: any) {
    if (!localStorage.getItem('navigateUpdateSstaDocument')) {
      localStorage.setItem("navigateUpdateSstaDocument", "/actualizar-ssta/" + this.idSsta)
    }
    this.router.navigate(["/document/SST/" + idSst]);
  }

  navegarDocumentSsta(ssta: any) {
    this.router.navigate(["/document/actualizar/SSTA/" + ssta.id], { state: { ssta: ssta, url: "/actualizar-ssta/" + this.idSsta } });
  }

  get transportGuideArray(): FormArray {
    return this.form.get("transportGuideArray") as FormArray;
  }

  createTransportGuide(transportGuide?: any) {
    return new FormGroup({
      transportGuide: new FormControl(transportGuide || "", [
        Validators.required,
        Validators.min(1),
      ]),
    });
  }

  addTransportGuide() {
    let newGuide = this.createTransportGuide();
    this.transportGuideArray.push(newGuide);
  }

  deleteTransportGuide(idx: number) {
    this.transportGuideArray.removeAt(idx);
  }


}